import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import PanelTemplate from "../../templates/Panel";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import Box from "../../components/Box";
import Table from "../../components/Table";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import Input from "../../components/Input";
import { convertIntToMoney, convertMoenyToInt } from "../../helpers/conversions";
import states from "../../seeds/states";
import axios from "axios";
import InputTextarea from "../../components/InputTextarea";
import { toast } from "react-toastify";
import InputEditorTiny from "../../components/InputEditorTiny";
import InputCheckboxUnique from "../../components/InputCheckboxUnique";
import { hasPermission } from "../../services/auth";
import SelectAddress from "../../components/selects/SelectAddress";
import { Loading } from "../../components/Loading";
import PaymentConditionFields from "../../components/PaymentCondition";
import { emptyPayment, paymentFromResource, paymentPayload } from "../../components/PaymentCondition/helpers";
import SelectShippingCompany from "../../components/selects/SelectShippingCompany";

const recipientTypes = [
    {label: 'Pessoa física', value: 'PF'},
    {label: 'Pessoa jurídica', value: 'PJ'}
];

const shippingTypes = [
    {label: 'CIF - Não aparece no PDF', value: 'CIF'},
    {label: 'FOB - Aparece no PDF', value: 'FOB'}
];

export const OrderCreate = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [gettingQuote, setGettingQuote] = useState(false);
    const [storingOrder, setStoringOrder] = useState(false);

    const [quote, setQuote] = useState(null);

    const [replace, setReplace] = useState(false);
    const [replaceCode, setReplaceCode] = useState(0);

    const [shippingFee, setShippingFee] = useState('R$ 0,00');
    const [shippingTime, setShippingTime] = useState(0);
    const [shippingCompany, setShippingCompany] = useState([]);
    const [shippingRecipientName, setShippingRecipientName] = useState('');

    const [payment, setPayment] = useState(emptyPayment);

    const [comments, setComments] = useState('');

    const [shippingAddressId, setShippingAddressId] = useState(null);
    const [billingAddressId, setBillingAddressId] = useState(null);

    useEffect(() => {
        getQuote();
    }, []);

    const getQuote = () => {
        setGettingQuote(true);

        api.get(`/budget/${id}`).then(res => {
            let resource = res.data.resource;
            setQuote(resource);
            setShippingAddressId(resource.shipping_address_id);
            setShippingCompany(resource.shipping_company_id);            
            setShippingFee('R$ ' + convertIntToMoney(resource.shipping_fee));
            setShippingTime(resource.shipping_time);
            setShippingRecipientName(resource.customer.name);
            setPayment(paymentFromResource(resource));
            setComments(resource.admin_comments);
        }).catch(error => {
            renderError(error);
        }).then(() => setGettingQuote(false));
    }

    const store = () => {
        setStoringOrder(true);
        
        api.post(`/order`, {
            budget_id: quote.id,
            replace_code: replace ? replaceCode : null,
            shipping_address_id: shippingAddressId,
            shipping_company_id: shippingCompany,
            billing_address_id: billingAddressId,
            shipping_fee: convertMoenyToInt(shippingFee),
            shipping_time: shippingTime,
            shipping_recipient_name: shippingRecipientName,
            ...paymentPayload(payment),
            comments,
        }).then(res => {
            toast.success(`Pedido emitido com sucesso`);
            registerEvents(res.data.resource);
            navigate(`/order/edit/${res.data.resource.id}`);
        }).catch(error => {
            renderError(error);
        }).then(() => setStoringOrder(false));
    }

    const registerEvents = order => {
        if(window.dataLayer === undefined) return ;

        let products = [];

        order.items.map(item => {
            products.push({
                id: item.subproduct_sku,
                name: `${item.product_name} ${item.color_name}`,
                price: item.price / 100,
                variant: item.color_name,
                quantity: item.quantity,
            });
        });

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: `${order.budget.code}`,
                        affiliation: order.budget.origin,
                        revenue: order.total / 100
                    },
                    products
                }
            }
        });
    }

    return (
        <>
            {gettingQuote &&
                <Loading />
            }
            {!gettingQuote && quote &&
                <PanelTemplate id="order-create">
                    <Box
                        title={`Dados do pedido`}
                    >
                        {replace &&
                            <div className="col-3">
                                <Input
                                    label={`Código do pedido`} 
                                    value={replaceCode}
                                    change={setReplaceCode}
                                    mask={'convertToInt'}
                                    placeholder={`Ex: 120`}
                                />
                                {replace &&
                                    <p>O pedido com o código informado acima <b>será removido</b> e substituído por este que você está criando.</p>
                                }
                            </div>
                        }
                        <div className="row">
                            <div className="col-3">
                                {hasPermission('replace_order') &&
                                    <div className="col-9" style={{ display: 'flex', alignItems: 'center', marginTop: replace ? 20 : 0}}>
                                        <InputCheckboxUnique checked={replace} change={setReplace} label={`Substituir pedido existente`} />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <Input label={`Código do orçamento`} value={quote?.code} disabled={true} />
                            </div>
                            <div className="col-3">
                                <Input label={`Pedido do cliente`} value={quote?.customer_purchase_order} disabled={true} />
                            </div>
                        </div>
                        <InputEditorTiny label={`Observações`} value={comments} change={setComments} />
                    </Box>
                    <div className="row">
                        <div className="col-6">
                            <Box title={`Entrega`}>
                                <SelectShippingCompany 
                                    selectedShippingCompany={shippingCompany}
                                    setSelectedShippingCompany={setShippingCompany}
                                    create={true}
                                />
                                <SelectAddress
                                    type={`shipping`}
                                    customerId={quote.type === 'PJ' ? null : quote.customer_id}
                                    companyId={quote.type === 'PJ' ? quote.company_id : null}
                                    addressId={shippingAddressId}
                                    setAddressId={setShippingAddressId}
                                />

                                <div className="row">
                                    <div className="col-6">
                                        <Input 
                                            label={`Valor do frete`}
                                            value={shippingFee}
                                            change={setShippingFee}
                                            mask={`convertToMoney`}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <Input 
                                            label={`Prazo de entrega`}
                                            value={shippingTime}
                                            change={setShippingTime}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <Input 
                                            label={`Quem irá receber`}
                                            value={shippingRecipientName}
                                            change={setShippingRecipientName}
                                            placeholder={`Nome de quem irá receber o pedido`}
                                        />
                                    </div>
                                </div>
                            </Box>
                        </div>
                        <div className="col-6">
                            <Box title={`Pagamento`}>
                                <SelectAddress
                                    type={`billing`}
                                    customerId={quote.type === 'PJ' ? null : quote.customer_id}
                                    companyId={quote.type === 'PJ' ? quote.company_id : null}
                                    addressId={billingAddressId}
                                    setAddressId={setBillingAddressId}
                                />
                                <div className="row">
                                    <PaymentConditionFields
                                        value={payment}
                                        change={setPayment}
                                        termClassName={`col-6`}
                                        methodClassName={`col-6`}
                                    />
                                </div>
                            </Box>
                        </div>
                    </div>
                    
                    <PageFooter>
                        <Button type={`primary`} size={`small`} svg={`save-white`} text={`Emitir pedido`} action={store} loading={storingOrder} />
                    </PageFooter>
                </PanelTemplate>
            }
        </>
    );
}

export default OrderCreate;